import * as React from "react";
import { Checkbox } from "antd";
import { formSet, formSetValue, useCpFormValue } from "./utils";
import { store } from "../../../store";
import { CheckboxGroupProps } from "antd/es/checkbox/Group";
import { useCpFormContext } from "../../../components/form/useCpFormContext";

interface Props extends Omit<CheckboxGroupProps, "id" | "name" | "value" | "status"> {
  name: string;
}
export const CpCheckboxGroup = (props: Props): React.ReactElement => {
  const { id } = useCpFormContext();
  const { name, onChange, ...radioGroupProps } = props;

  const value = useCpFormValue(name);

  const fieldStatePath = React.useMemo(() => `fieldStates.${name}`, [name]);

  React.useEffect(() => {
    formSet(id, `fieldStates.${name}.visited`, true);
    formSet(id, `fieldStates.${name}.touched`, true);
  }, []);

  return (
    <div id={name}>
      <Checkbox.Group
        {...radioGroupProps}
        value={value}
        onChange={(checkedValues) => {
          onChange?.(checkedValues);
          formSetValue(id, name, checkedValues);
          formSet(id, `${fieldStatePath}.modified`, true);

          const form = store.getState().form.instances[id];

          const onChangeCounter = form.meta.onChangeCounter;
          formSet(id, `meta.onChangeCounter`, onChangeCounter + 1);

          const onBlurCounter = form.meta.onBlurCounter;
          formSet(id, `meta.onBlurCounter`, onBlurCounter + 1);
        }}
      />
    </div>
  );
};
